import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs";
import { ConfigService } from "src/app/core/config.service";
import { IacRepositoriesChartsData, IacRepositoryDetails, IacRepositories} from "./iac-repositories.model";
import {IacRepositoryTypeEnum} from "src/app/shared/enum/iac-repository-type.enum";

@Injectable({
    providedIn: 'root'
})
export class IacRepositoriesGithubService {

    constructor(private httpClient: HttpClient, private configService: ConfigService){

    }

    loadIacGithubRepositories(){
        return this.httpClient.get<IacRepositories>(`${this.configService.config.apiUrl}/iac/repositories/github`)
        .pipe(
            map((response=>{
                const data = []
                const repositoryEnumKeys = Object.keys(IacRepositoryTypeEnum);
                for(let type in response){
                    const repositories = response[type as keyof IacRepositories]
                    if(repositoryEnumKeys.includes(type)){
                        data.push(...repositories.checked.map((value) => {return {...value, type: type, allBadges: value.checked.concat(value.unchecked).concat(value.ignored)}}))
                        data.push(...repositories.unchecked.map((value) => {return {...value, type: type, allBadges: value.checked.concat(value.unchecked).concat(value.ignored)}}))
                        data.push(...repositories.ignored.map((value) => {return {...value, type: type, allBadges: value.checked.concat(value.unchecked).concat(value.ignored)}}))
                    }
                }
                return data
            }))
        )
    }

    loadIacGithubRepositoryDetails(repositoryId: string){
        return this.httpClient.get<IacRepositoryDetails>(`${this.configService.config.apiUrl}/iac/repositories/github/details?repository_id=${repositoryId}`)
        .pipe(
            map((response=>{
                // The API returns an empty object when the repository is unknown
                response.allBadges = (response.checked ?? []).concat(response.unchecked ?? []).concat(response.ignored ?? [])
                return response
            }))
        )
    }

    loadIacGithubRepositoriesMeasures(start_date: string, end_date: string, granularity: string){
        return this.httpClient.get<IacRepositoriesChartsData>(`${this.configService.config.apiUrl}/iac/repositories/github/measures?start_date=${start_date}&end_date=${end_date}&granularity=${granularity}`)
    }
}
